export default "/images/vendor/@coreui/icons/svg/flag/cif-de.svg?830431217fc3d551f675c26c794e974e";